(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/controllers/betslip-controller.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/controllers/betslip-controller.js');

'use strict';

svs.maltipset.controllers.Betslip = Marionette.MnObject.extend({
  initialize: function() {
    var self = this;
    self.coupon = self.options.coupon;
    self.maltipsetController = self.options.controller;
    self.storeState = {
      type: '',
      product: 'maltipset',
      validOpenState: self.coupon.get('isValid')
    };
    self.relativeLayout = true;
    self.listenTo(self.coupon, 'change:isValid', self.toggleFooter, self);
    self.listenTo(
      self.coupon,
      'destroyBetslipAfterPayment',
      function() {
        self.maltipsetController.betslip.getRegion('betslipFooter').reset();
        self.maltipsetController.betslip
          .getRegion('betslipFooter')
          .trigger('destroy');
        self.maltipsetController.betslip.collapseBetslip();
      },
      self
    );
  },

  toggleFooter: function() {
    if (
      !this.maltipsetController.betslip.getRegion('betslipFooter')
        .currentView &&
      !this.coupon.get('xpertBaseRowMode')
    ) {
      this.maltipsetController.betslip
        .getRegion('betslipFooter')
        .show(new svs.maltipset.views.BetslipFooter({ model: this.coupon }));
      svs.sport.actionbar.reposition();
      this.parentNode = this.maltipsetController.betslip
        .getRegion('betslipFooter')
        .currentView.$el.parents('.betslip');
      this.parentNode.removeClass('betslip-footer-hidden');
    }
    svs.sport.actionbar.reposition();
  },

  additionalScrollHeight: function(betslip) {
    betslip.overload.betslipOffsetTop = svs.core.detect.formfactor.mobile() ?
      betslip.overload.betslipPosition.offset().top :
      betslip.overload.scrollContentHeight;

    betslip.overload.scrollHeight =
      betslip.overload.scrollContainerHeight - 44;
  },

  initRelativeBetslip: function() {
    var self = this;
    this.scrollContent = svs.core.detect.formfactor.mobile() ?
      $('#main-content') :
      $('#coupon');
    if (!svs.core.detect.formfactor.mobile()) {
      this.swiperContainer = $('.js-swiper-container');
    }
    this.betslipWrapper = $('#betslip-wrapper');
    this.betslipPosition = $('.betslip-position-tag');
    this.actionbar = $('#action-wrapper');
    this.betslipFooter = $('#betslip-footer');

    this.betslipWrapper.width(this.scrollContent[0].clientWidth);
    this.actionbar.width(this.scrollContent[0].clientWidth);

    if (!svs.core.detect.formfactor.mobile()) {
      $(window).on('resize', function() {
        self.betslipWrapper.width(self.scrollContent[0].clientWidth);
        self.actionbar.width(self.scrollContent[0].clientWidth);
      });

      $(window).on('resizeMultiSwiper', function() {
        self.betslipWrapper.width(self.overload.scrollContent[0].clientWidth);
        self.actionbar.width(self.scrollContent[0].clientWidth);
      });
    }
    this.betslipFooter.off('click', _.bind(this.scrollToBetslip, this));
    this.betslipFooter.on('click', _.bind(this.scrollToBetslip, this));
    this.maltipsetOverviewToogle = true;
  },

  scrollToBetslip: function(e) {
    e.preventDefault();
    var scrollToBetslip = this.scrollContent.height();
    if (svs.core.detect.formfactor.mobile()) {
      $('html, body')
        .stop()
        .animate({ scrollTop: scrollToBetslip }, 400, 'swing');
    } else {
      $(this.swiperContainer)
        .has('#coupon')
        .stop()
        .animate({ scrollTop: scrollToBetslip }, 400, 'swing');
    }
  },

  showOverview: function() {
    if (svs.core.detect.formfactor.mobile()) {
      var betslipOverview = new svs.maltipset.views.BetslipOverview({
        coupon: this.coupon
      }).render().$el;

      svs.components.Modal.show(betslipOverview, null, {
        title: 'Översikt av spelet',
        headerClass: 'header-maltipset',
        dontPushModalToHistory: true,
        modalHistory: true,
        leftButton: {
          text: 'Stäng',
          visible: true,
          cssClass: 'btn-transparent-inverted',
          callback: function() {
            svs.components.Modal.hide();
            return false;
          }
        },
        rightButton: {
          visible: false
        }
      });
    } else {
      var maltipsetSliderFolder = $('.maltipset-slider-folder');
      var maltipsetSliderFolderDimmer = $('.maltipset-betslipoverview-dimmer');

      if (this.maltipsetOverviewToogle) {
        maltipsetSliderFolder
          .removeClass('no-transition')
          .toggleClass('maltipset-slider-folder-open');
        maltipsetSliderFolderDimmer
          .removeClass('no-transition')
          .toggleClass('maltipset-betslipoverview-dimmer-visible');
      } else {
        maltipsetSliderFolder
          .addClass('no-transition')
          .toggleClass('maltipset-slider-folder-open');
        maltipsetSliderFolderDimmer
          .addClass('no-transition')
          .toggleClass('maltipset-betslipoverview-dimmer-visible');
      }
    }
  },

  openBetslip: function() {
  },

  closeBetslip: function(betslip) {
    betslip
      .getRegion('betslipFooter')
      .show(new svs.maltipset.views.BetslipFooter({ model: this.coupon }));
  },

  collapseBetslip: function(betslip) {
    betslip.isOpen = false;
    betslip.getRegion('betslipFooter').reset();
    betslip.getRegion('betslipContent').reset();
    if (betslip.$el) {
      betslip.$el.addClass('betslip-footer-hidden');
    }
  }
});


 })(window);